import authImage from "../assets/images/authSvg.svg";
import logo from "assets/images/logoSvg.svg";
import { routePath } from "config/routeMgt/routePath";
import { Link, useParams } from "react-router-dom";
import "../assets/style.css";
import { ForgotPasswordForm } from "../components/ForgotPasswordForm";

export const ForgotPassword = () => {
  const { type } = useParams();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-screen overflow-auto">
      {/* LEFT */}
      <div className="Container py-6 bg-white flex flex-col h-full">
        {/* Logo */}
        <div className="mt-2">
          <a
            href="https://www.arnopro.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="logo" />
          </a>
        </div>

        {/* Content */}
        <div className="flex justify-center flex-1 mt-10">
          <div className="w-full max-w-md">
            {/* Title */}
            <div className="mb-8">
              <h2 className="text-3xl font-semibold text-gray-900 mb-3">
                Forgot password
              </h2>
              <p className="text-gray-500 text-base leading-relaxed">
                Fill in your email and we will send you a code to reset your
                password.
              </p>
            </div>

            {/* Form */}
            <ForgotPasswordForm />

            {/* Back */}
            <div className="text-center text-sm mt-6">
              <span className="text-gray-500">Want to go back? </span>
              <Link
                to={`/sign-in/${type || "talent"}`}
                className="text-primary font-medium"
              >
                Sign in
              </Link>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-sm flex items-center justify-center gap-16 pt-12 mt-auto pb-10">
          <a
            href="https://www.arnopro.com/arno-terms-of-use"
            className="underline"
            target="_blank"
            rel="noreferrer"
          >
            Terms & Conditions
          </a>
          <a
            href="https://www.arnopro.com/arno-data-privacy-policy"
            className="underline"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.arnopro.com/arno-cookies-policy"
            className="underline"
            target="_blank"
            rel="noreferrer"
          >
            Cookies Policy
          </a>
        </div>
      </div>

      {/* RIGHT */}
      <div className="bg-primary h-screen Container lg:flex items-center justify-center hidden w-full sticky top-0">
        <video
          src="/assets/authVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};
